var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import v23Schema from '../client/schemaVersions/v23.js';
import v24Schema from '../client/schemaVersions/v24.js';
import { createMigration } from '@verdant-web/store';
export default createMigration(v23Schema, v24Schema, async ({ migrate }) => {
    // add or modify migration logic here
    // if a line has a type error, that indicates the shape of your models may have changed
    // rename field
    await migrate('items', function procedure(_a) {
        var { expiredAt } = _a, old = __rest(_a, ["expiredAt"]);
        return Object.assign(Object.assign({}, old), { expiresAt: expiredAt });
    });
});
//# sourceMappingURL=v24.js.map